/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon20Light = forwardRef('ArrowADownRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.26 15.966c-.084.022-.17.034-.26.034H6.5a.5.5 0 0 0 0 1H15a2 2 0 0 0 2-2V6.5a.5.5 0 0 0-1 0V15a1 1 0 0 1-.034.259L4.354 3.646a.5.5 0 1 0-.708.708L15.26 15.966Z" })));
});
